import { SubmissionError } from 'redux-form/immutable';

/**
 * Error message that can safely be displayed to the user when a submission was returned as invalid.
 */
export default class SubmissionErrorWithErrorCodes extends SubmissionError {

  /**
   * @param {object} errors
   * @param {object} errorCodes
   */
  constructor(errors, errorCodes) {

    // noinspection JSCheckFunctionSignatures
    super(errors);

    this.errorCodes = errorCodes;

  }

}


// WEBPACK FOOTER //
// ./src/errors/SubmissionErrorWithErrorCodes.js